import React, { useEffect, useState } from 'react';
import warningIcon from 'images/icons/warning-red.svg';
import Modal, { Footer } from '@/components/common/Modal';

interface TypeToConfirmModalProps {
  className?: string;
  close: () => void;
  confirmationPrompt?: React.ReactNode | string;
  confirmationText?: string;
  confirmationButtonText?: string;
  error?: boolean;
  headerText: string;
  isOpen: boolean;
  onSubmit: (e: any) => Promise<any>;
  submitting: boolean;
  warningIcon?: string;
  warningMessage?: string;
}

// TypeToConfirmModal - A reusable modal for requiring typing a word before being able to submit
const TypeToConfirmModal = ({
  className = '!tw-border-none',
  close,
  confirmationPrompt,
  confirmationText = 'DELETE',
  confirmationButtonText = 'Delete',
  error,
  headerText,
  isOpen,
  onSubmit,
  submitting,
  warningIcon: customWarningIcon = warningIcon,
  warningMessage = 'This action cannot be undone.',
}: TypeToConfirmModalProps) => {
  const [inputValue, setInputValue] = useState('');

  const resetTextBoxOnModalClose = () => {
    if (!isOpen) setInputValue('');
  };

  useEffect(() => {
    resetTextBoxOnModalClose();
  }, [isOpen]);

  return (
    <Modal
      className={className}
      closeButtonClassName="tw-text-white hover:tw-text-white"
      closeModal={close}
      error={error}
      headerClass="tw-bg-red tw-text-white"
      headerText={headerText}
      headerTextClassName="tw-text-white"
      isOpen={isOpen}
    >
      {confirmationPrompt && (
        <div className="tw-leading-5">
          {confirmationPrompt}
        </div>
      )}

      {warningMessage && (
        <div className="tw-flex tw-align-center tw-my-5 tw-h-4">
          <img
            alt="Warning"
            className="tw-mr-3"
            src={customWarningIcon}
          />
          <span className="tw-flex tw-align-center">
            {warningMessage}
          </span>
        </div>
      )}

      <div>
        Type <strong>{confirmationText}</strong> to confirm:
        <input
          className="tw-w-full tw-mt-2 tw-p-2 tw-border tw-rounded"
          type="text"
          value={inputValue}
          onChange={e => setInputValue(e.target.value)}
        />
      </div>

      <form onSubmit={onSubmit}>
        <Footer
          primaryButtonClassName="btn btn--red"
          primaryButtonDisabled={inputValue !== confirmationText}
          primaryButtonText={confirmationButtonText}
          secondaryButtonCallback={close}
          submitting={submitting}
        />
      </form>
    </Modal>
  );
};

export default TypeToConfirmModal;
